/** Shop types accepted as local partners (must match backend LOCAL_PARTNER_TYPES). */
export const LOCAL_PARTNER_TYPES = new Set([
  'flower_shop',
  'gift_shop',
  'car_rental',
  'coffee_shop',
  'perfume_shop',
  'herbalist_shop',
  'spa',
  'laundry',
  'pharmacy',
  'tour',
  'grocery',
  'bakery',
  'convenience',
  'maintenance',
  'cleaning',
  'electronics_repair',
  'beauty_salon',
  'pet_shop',
  'hardware',
  'other',
]);

export const TYPE_LABELS = {
  flower_shop: 'Flower shop',
  gift_shop: 'Gift shop',
  car_rental: 'Car rental',
  coffee_shop: 'Coffee shop',
  perfume_shop: 'Perfume shop',
  herbalist_shop: 'Herbalist shop',
  spa: 'Spa',
  laundry: 'Laundry',
  pharmacy: 'Pharmacy',
  tour: 'Tour / activities',
  grocery: 'Grocery',
  bakery: 'Bakery',
  convenience: 'Convenience store',
  maintenance: 'Maintenance services',
  cleaning: 'Cleaning services',
  electronics_repair: 'Electronics repair',
  beauty_salon: 'Beauty salon',
  pet_shop: 'Pet shop',
  hardware: 'Hardware / tools',
  other: 'Other',
};

/** Neighbour discovery radius only — keep tight for walkable towers. */
export const RADIUS_OPTIONS = [0.5, 1, 1.5];

export const DISPLAY_CURRENCIES = [
  'AED',
  'USD',
  'EUR',
  'GBP',
  'SAR',
  'QAR',
  'KWD',
  'BHD',
  'OMR',
  'EGP',
  'INR',
  'PKR',
];

/** Neighbour delivery fee options by display currency (mirrors backend lp_delivery_fees). */
export const DELIVERY_FEE_OPTIONS = {
  AED: [0, 0.5, 1],
  SAR: [0, 0.5, 1, 2],
  QAR: [0, 0.5, 1, 2],
  BHD: [0, 0.1, 0.2, 0.5],
  KWD: [0, 0.1, 0.25, 0.5],
  OMR: [0, 0.1, 0.2, 0.5],
  USD: [0, 0.5, 1],
  EUR: [0, 0.5, 1],
  GBP: [0, 0.5, 1],
  EGP: [0, 5, 10],
  INR: [0, 20, 50],
  PKR: [0, 50, 100],
};

export function feeOptionsForCurrency(currency, apiOptions) {
  if (Array.isArray(apiOptions) && apiOptions.length) {
    return apiOptions.map((n) => Number(n)).filter((n) => Number.isFinite(n));
  }
  const cur = String(currency || 'AED')
    .trim()
    .toUpperCase()
    .slice(0, 3);
  return DELIVERY_FEE_OPTIONS[cur] || DELIVERY_FEE_OPTIONS.AED;
}

export function formatFeeOption(amount, currency) {
  const n = Number(amount);
  const cur = String(currency || 'AED').toUpperCase();
  if (!Number.isFinite(n) || n === 0) return `Free (0 ${cur})`;
  return `${n.toFixed(n % 1 === 0 ? 0 : 2)} ${cur}`;
}

/** Neighbour resident-order language preferred by LP staff (backend: en|ur|hi|ml|fil). */
export const ORDER_LANG_OPTIONS = [
  { value: 'en', label: 'English' },
  { value: 'ur', label: 'Urdu' },
  { value: 'hi', label: 'Hindi' },
  { value: 'ml', label: 'Malayalam' },
  { value: 'fil', label: 'Filipino / Tagalog' },
];

export function orderLangLabel(code) {
  const c = String(code || 'en')
    .trim()
    .toLowerCase();
  return ORDER_LANG_OPTIONS.find((o) => o.value === c)?.label || 'English';
}

export const SUPPORT_WHATSAPP = '971506367114';
export const SUPPORT_WHATSAPP_URL = `https://wa.me/${SUPPORT_WHATSAPP}`;

export const TOKEN_KEY = 'lp_vendor_token';
export const VENDOR_KEY = 'lp_vendor';

export const PORTAL_URL =
  import.meta.env.VITE_PORTAL_URL || 'https://local.gosnel.com';

export function isLocalPartnerType(vendorType) {
  const vt = String(vendorType || '')
    .trim()
    .toLowerCase();
  return LOCAL_PARTNER_TYPES.has(vt);
}

export function typeLabel(vendorType) {
  const vt = String(vendorType || '')
    .trim()
    .toLowerCase();
  return TYPE_LABELS[vt] || vt || 'Shop';
}

export function vendorCurrency(vendor) {
  return (
    vendor?.display_currency ||
    vendor?.bank_currency ||
    'AED'
  );
}
